<div class="modal-header">
  <div class="d-title-main">
    How It Works
  </div>
  <span class="material-icons cursor-pointer" (click)="closeModal()">
    close
  </span>
</div>
<div class="modal-body">
  <div>
    <video muted controls id="myVideo" class="w-100" #sliderVideo5 preload="none"
      poster="{{assetURL}}/assets/images/Step1_Frame1.jpg">
      <source src="{{assetURL}}/assets/Video/Mobile_Guide.mp4" type="video/mp4" />
    </video>
  </div>
</div>